import { isDev } from './is-dev';
import { isStaging } from './is-staging';

export const getApiUrlFromWindowLocation = () => {
  return isDev ? `http://${window.location.hostname}:4002` :
    isStaging ? `${window.location.protocol}//api.staging.volaby.org` :
      `${window.location.protocol}//api.volaby.org`
};
